import type { BoardTheme } from "../../shared/recaps/themeBoard.ts";

export interface BoardRenderState {
  byId: Map<string, { revision: number }>;
}

export interface BoardCard extends BoardTheme {
  /** New to the board since the previous render — plays the entrance animation. */
  entered: boolean;
  /** Revision increased since the previous render — plays the update wash. */
  updated: boolean;
}

/** Pure derivation of animation flags from the previous render state.
 *  First render and fallback cycles animate nothing (spec: no initial-load
 *  animation; heuristic-identity cycles must not make public update claims). */
export function deriveBoardView(input: {
  boardThemes: BoardTheme[];
  themeIdFallback: boolean;
  previous: BoardRenderState | null;
}): { cards: BoardCard[]; nextState: BoardRenderState } {
  const animate = input.previous !== null && !input.themeIdFallback;
  const cards = input.boardThemes.map((boardTheme) => {
    const previousEntry = input.previous?.byId.get(boardTheme.themeId);
    return {
      ...boardTheme,
      entered: animate && previousEntry === undefined,
      updated: animate && previousEntry !== undefined && boardTheme.revision > previousEntry.revision,
    };
  });
  return {
    cards,
    nextState: {
      byId: new Map(
        input.boardThemes.map((boardTheme) => [boardTheme.themeId, { revision: boardTheme.revision }]),
      ),
    },
  };
}
